import { TRPCProvider as TRPCContextProvider } from "@/trpc/client"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { createTRPCClient, httpBatchLink } from "@trpc/client"
import { PropsWithChildren, useState } from "react"
import type { RentalsOwnerPortalRouter } from "@src/backend/src/rentals/functions/ownerPortal"

export function TRPCProvider({ children }: PropsWithChildren<{}>) {
  const [queryClient] = useState(() => new QueryClient())

  const [trpcClient] = useState(() =>
    createTRPCClient<RentalsOwnerPortalRouter>({
      links: [
        httpBatchLink({
          url: import.meta.env.VITE_TRPC_API_URL || "http://localhost:3000",
          async headers() {
            return {}
          },
        }),
      ],
    })
  )

  return (
    <TRPCContextProvider trpcClient={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </TRPCContextProvider>
  )
}
